<div class="audit-date-row">
	<div class="row-wrapper">
		<div class="col-md-6 audit-date-label-flex">
			<label class="date-label float-left">{{'additional-questions.audit-dates.next-audit-date' | translate}}</label>
		</div>
	</div>
	<div class="row-wrapper">
		<div class="col-md-6">
			<date-picker [id]="'desired-next-audit-date'" [controlName]="'desiredNextAuditDate' + product.standard.name" [formGroup]="form" [value]="product.additionalQuestions.desiredNextAuditDate"
						 (onDateChangeInDefault)="updateDateFormControlAndValidateAllDates('desiredNextAuditDate', $event)"
						 [invalidDate]="isInvalid('desiredNextAuditDate')">
			</date-picker>
			<div class="validation-message">{{getErrorsIfInvalid('desiredNextAuditDate') | async}}</div>
		</div>
	</div>
</div>
